var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9584 5.83301C18.9584 6.17818 18.6785 6.45801 18.3334 6.45801H1.66669C1.32151 6.45801 1.04169 6.17818 1.04169 5.83301C1.04169 5.48783 1.32151 5.20801 1.66669 5.20801H18.3334C18.6785 5.20801 18.9584 5.48783 18.9584 5.83301Z",
    fill: "#5F6D8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4584 10C16.4584 10.3452 16.1785 10.625 15.8334 10.625H4.16669C3.82151 10.625 3.54169 10.3452 3.54169 10C3.54169 9.65483 3.82151 9.375 4.16669 9.375H15.8334C16.1785 9.375 16.4584 9.65483 16.4584 10Z",
    fill: "#5F6D8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9584 14.167C13.9584 14.5122 13.6785 14.792 13.3334 14.792H6.66669C6.32151 14.792 6.04169 14.5122 6.04169 14.167C6.04169 13.8218 6.32151 13.542 6.66669 13.542H13.3334C13.6785 13.542 13.9584 13.8218 13.9584 14.167Z",
    fill: "#5F6D8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortSvgrepoCom);
export default __webpack_public_path__ + "static/media/sort-svgrepo-com.10eb7a5057e612ad0051dfd02ac2855b.svg";
export { ForwardRef as ReactComponent };